import { render, staticRenderFns } from "./Uporabnik.vue?vue&type=template&id=33305df3&scoped=true"
import script from "./Uporabnik.vue?vue&type=script&lang=js"
export * from "./Uporabnik.vue?vue&type=script&lang=js"
import style0 from "./Uporabnik.vue?vue&type=style&index=0&id=33305df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33305df3",
  null
  
)

export default component.exports